import React, { useContext } from 'react'
import PreviewerContext, {
  PreviewerTheme,
} from '@apphiveio/controlsmanager/PreviewerContext'
import PreviewerPageWrapper from '@apphiveio/controlsmanager/components/PreviewerPageWrapper'
import PreviewerLottieApphiveLoading from 'components/PreviewerLottieApphiveLoading'

const style = {
  lottieStyle: {
    width: 200,
    height: 200,
  },
  label: {
    color: PreviewerTheme.colors.primary.text,
    fontWeight: 'bold',
  },
} as const

type Props = {
  message: string
  background?: 'primary'
  backgroundColor?: string
}

const PreviewerPageSplash: React.VFC<Props> = ({
  message,
  background,
  backgroundColor,
}) => {
  const { Render } = useContext(PreviewerContext)

  return (
    <PreviewerPageWrapper
      background={background}
      backgroundColor={backgroundColor}
      centerItems
    >
      <PreviewerLottieApphiveLoading style={style.lottieStyle} />
      <Render.Text style={style.label}>{message}</Render.Text>
    </PreviewerPageWrapper>
  )
}

export default PreviewerPageSplash
